// src/utils/phone.js
import { parsePhoneNumberFromString } from "libphonenumber-js";

// Pretty format E.164
export function prettyFormat(e164) {
  try {
    const num = parsePhoneNumberFromString(e164);
    return num ? num.formatInternational() : e164;
  } catch {
    return e164;
  }
}

/**
 * Build E.164 from cc + local digits.
 * - UI picker already restricts allowed country codes (SADC + Diaspora)
 * - This util must ONLY:
 *   1) normalize digits
 *   2) validate number
 *   3) return E.164
 */
export function toE164FromCcLocal(ccPlus, localDigits) {
  const cc = String(ccPlus || "").replace(/\s+/g, "");
  let local = String(localDigits || "").replace(/\D/g, "");

  if (!cc.startsWith("+") || !local) return null;

  // Drop a single trunk '0' (common in many countries)
  if (local.startsWith("0")) local = local.slice(1);

  const candidate = `${cc}${local}`;

  // Because candidate starts with +, we do NOT need a default country.
  const num = parsePhoneNumberFromString(candidate);

  if (!num) return null;
  if (!num.isValid()) return null;

  return num.number; // E.164
}

// Split E.164 into country code and national digits for UI prefill.
export function splitE164ToCcLocal(e164) {
  const raw = String(e164 || "").trim();
  if (!raw) return null;
  try {
    const num = parsePhoneNumberFromString(raw);
    if (!num || !num.isValid()) return null;
    return {
      cc: `+${num.countryCallingCode}`,
      local: String(num.nationalNumber || "").replace(/\D/g, ""),
      e164: num.number,
    };
  } catch {
    return null;
  }
}
